import type { CSSProperties } from "react";
import { NavLink } from "./NavLink";
import { CollapsibleContent } from "./ui/collapsible";
import {
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "./ui/sidebar";
import {
  PTS_SIDEBAR_ICON_CENTER_OFFSET,
  PTS_SIDEBAR_SUB_BUTTON_CLASS,
  PTS_SIDEBAR_SUB_LINK_ACTIVE_CLASS,
  PTS_SIDEBAR_SUB_LINK_CLASS,
  PTS_SIDEBAR_SUB_MENU_CLASS,
} from "./ptsSidebarSubNavStyles";

interface PtsSidebarSubNavListProps {
  children: React.ReactNode;
}

export const PtsSidebarSubNavList = ({
  children,
}: PtsSidebarSubNavListProps) => (
  <CollapsibleContent
    className="mt-1"
    style={
      {
        "--pts-sidebar-icon-center": PTS_SIDEBAR_ICON_CENTER_OFFSET,
      } as CSSProperties
    }
  >
    <SidebarMenuSub className={PTS_SIDEBAR_SUB_MENU_CLASS}>
      {children}
    </SidebarMenuSub>
  </CollapsibleContent>
);

interface PtsSidebarSubNavItemProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
  end?: boolean;
}

export const PtsSidebarSubNavItem = ({
  to,
  isActive,
  children,
  end,
}: PtsSidebarSubNavItemProps) => (
  <SidebarMenuSubItem>
    <SidebarMenuSubButton
      asChild
      isActive={isActive}
      className={PTS_SIDEBAR_SUB_BUTTON_CLASS}
    >
      <NavLink
        to={to}
        end={end}
        className={PTS_SIDEBAR_SUB_LINK_CLASS}
        activeClassName={PTS_SIDEBAR_SUB_LINK_ACTIVE_CLASS}
      >
        {children}
      </NavLink>
    </SidebarMenuSubButton>
  </SidebarMenuSubItem>
);
